//---------------------------------------------------------
// HA Stage 1 pair DTOs (contract 0012 at bbb672f, sections 3 and 7).
// Mode string under Architect review: nat_onearm_ha on legacy_private.
//---------------------------------------------------------
export const HA_MODE = 'nat_onearm_ha';
export type HAPairHealth = 'healthy' | 'degraded' | 'down';
export type HANodeHealth = 'up' | 'down' | 'unknown';
export type HASyncState = 'in_sync' | 'saving' | 'out_of_sync' | 'unreachable';
export type HANodeIndex = 1 | 2;
export type HAPairState = 'provisioning' | 'active' | 'failed' | 'deleting' | 'delete_failed';

export interface HAApiError {
	code: string;
	message: string;
}

/** One GET /oam/loxilbs entry for a pair. Never carries a Linode id. */
export interface HAPairListItem {
	kind: 'ha_pair';
	pairId: string;
	name: string;
	host: string;
	mode: string;
	networkMode: string;
	region: string;
	ha: true;
	health: HAPairHealth;
	failedOver: boolean;
	state: HAPairState | string;
	createdAt?: string;
}

export interface HAPairNode {
	node: HANodeIndex;
	role: 'primary' | 'secondary';
	holdsVip: boolean | null;
	health: HANodeHealth;
	linodeStatus: string | null;
	publicIp: string;
	privateIp: string;
	/** Admin responses only. */
	linodeId?: number;
	instanceId: number | null;
	syncState: HASyncState;
	appliedRev: number | null;
	lastError: HAApiError | null;
}

export interface HAPairDetail {
	pairId: string;
	name: string;
	vip: string;
	mode: string;
	networkMode: string;
	region: string;
	state: HAPairState | string;
	health: HAPairHealth;
	failedOver: boolean;
	vipHolder: HANodeIndex | null;
	settingsRev: number;
	nodes: HAPairNode[];
}

/** Pair-wide settings objects (Q7). Everything else is node-local. */
export const HA_PAIR_WIDE_KINDS = ['loadbalancer', 'firewall', 'endpoint', 'mirror', 'policy'] as const;
export type HAPairWideKind = (typeof HA_PAIR_WIDE_KINDS)[number];
export type HASettingsDoc = Partial<Record<HAPairWideKind, Record<string, unknown>[]>>;

export interface HANodeSyncResult {
	node: HANodeIndex;
	syncState: HASyncState;
	appliedRev?: number;
	error?: HAApiError;
}

export interface HASaveResult {
	status: number;
	settingsRev?: number;
	result?: 'saved' | 'partial';
	nodes?: HANodeSyncResult[];
	error?: HAApiError;
	node?: HANodeIndex;
}

export interface HAPowerPreflight {
	node: HANodeIndex;
	linodeStatus: string | null;
	holdsVip: boolean | null;
	otherNodeDown: boolean | null;
	allowed: string[];
	linodeId?: number;
}

export type HAJobStepName = 'creating_node_1' | 'creating_node_2' | 'sharing_address' | 'ready';
export interface HAJobStep {
	step: HAJobStepName;
	state: 'pending' | 'running' | 'done' | 'failed' | 'not_reached';
}
